import { render, staticRenderFns } from "./ListeProduitArchived.vue?vue&type=template&id=2480a4e6"
import script from "./ListeProduitArchived.vue?vue&type=script&lang=js"
export * from "./ListeProduitArchived.vue?vue&type=script&lang=js"
import style0 from "./ListeProduitArchived.vue?vue&type=style&index=0&id=2480a4e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports